import {createFileRoute} from '@tanstack/react-router';
import {viewDiagnosticReportGranted, grantUser} from '@/practitioner/routing/utils/beforeLoadUtils';

import DiagnosticReportResult from '@/practitioner/views/diagnosticReport/DiagnosticReportResult';

export const Route = createFileRoute(
  '/(practitioner)/patients/$patientId/diagnostic-report/$diagnosticReportId'
)({
  component: DiagnosticReportResult,
  beforeLoad: grantUser(viewDiagnosticReportGranted),
  loader: ({params}) => ({
    patientId: params.patientId,
    diagnosticReportId: params.diagnosticReportId
  })
});
